import React, { CSSProperties } from "react";
import classNames from "classnames/bind";

import styles from "./InlineLoader.module.scss";
const cx = classNames.bind(styles);

type InlineLoaderProps = {
  height?: CSSProperties["height"];
  width?: CSSProperties["width"];
};

const InlineLoader = ({ height, width }: InlineLoaderProps) => {
  return (
    <div
      className={cx("skeleton")}
      style={{ height: height ?? "25px", width: width ?? "70%" }}
    />
  );
};

export default InlineLoader;
